import gql from 'graphql-tag';
import type { TypedDocumentNode } from '@graphql-typed-document-node/core';

interface CanAccessCropPlanningData {
  canAccessCropPlanning: boolean;
}

interface CanAccessCropPlanningVariables {
  userId?: string | null;
}

export const canAccessCropPlanningQuery = gql`
  query canAccessCropPlanning($userId: ID) {
    canAccessCropPlanning(userId: $userId)
  }
` as TypedDocumentNode<CanAccessCropPlanningData, CanAccessCropPlanningVariables>;
